import axios from '@/axios-api';
import Pathes from '@/helpers/pathes';
import { getQuery } from '@/helpers/utils';

export const reportService = {
  activityTypes: () => axios.get(Pathes.Activity.types),
  taxReports: params => axios.get(Pathes.Activity.taxReport + getQuery(params)),
  cashMovements: params =>
    axios.get(Pathes.Activity.cashMovements + getQuery(params)),
  portfolioMovements: params =>
    axios.get(Pathes.Activity.portfolioMovements + getQuery(params)),
};
